<div class="container">
  <div class="row">
    <div class="col-xs-12">
      <div class='page-header'>
        <h2 class="title">
          Dados para conexão do aplicativo mobile
        </h2>
      </div>
    </div>
    <div class="col-xs-12">
      <i class="fa fa-exclamation-triangle"></i>
      <small class="text-right">O uso do QRCode foi desabilitado!</small>
    </div>
  </div>

  <div class="row m-t-md">
    <div class="col-xs-3 col-xs-offset-3 text-center">
      <a href="http://play.google.com/store/apps/details?id=inf.agro1.agrogestao.app" target="_blank" title="Aqila Lavoura">
        <img src="images/icon-lavoura.png" style="max-height: 50px;">
      </a>
      <br>
      <small>Aqila Lavoura</small>
    </div>

    <div class="col-xs-3 text-center">
      <a href="http://play.google.com/store/apps/details?id=br.com.aqila.maquinas" target="_blank" title="Aqila Máquinas">
        <img src="images/icon-maquinas.png" style="max-height: 50px;">
      </a>
      <br>
      <small>Aqila Máquinas</small>
    </div>
  </div>

  <div class="row m-t-md">
    <div class="col-xs-12">
      <h3>Informações da conexão</h3>
      <table class="table">
        <tr>
          <td class="text-right">Descrição</td>
          <td><strong>{{configuration.description}}</strong></td>
        </tr>
        <tr>
          <td class="text-right">Servidor</td>
          <td><strong>{{configuration.servers}}</strong></td>
        </tr>
        <tr>
          <td class="text-right">Porta</td>
          <td><strong>{{configuration.port}}</strong></td>
        </tr>
        <tr>
          <td class="text-right">Protocolo</td>
          <td ng-class="{'text-success': configuration.scheme == 'https'}">
            <i ng-if="configuration.scheme == 'https'" class="fa fa-lock"></i>
            <strong>{{configuration.scheme}}</strong>
          </td>
        </tr>
      </table>
    </div>
  </div>
</div>
